//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The order type id
*
* 
*  * ORDER value: 1 - Bestellung - normal for customer 
*  * SAMPLE_DELIVERY value: 2 - Musterlieferung 
*  * ORGANIZER_TICKETS value: 3 - VeranstalterTickets - promoter order, problems with personalization 
*  * ORGANIZER_COSTS value: 4 - VeranstalterKosten 
*  * PRODUCT_COSTS value: 5 - Produktkosten 
*  * FREE_INVOICE value: 6 - freie Rechnung 
*  * ORDER_IMPORT value: 7 - Bestellimport - needed in ticket management 
*  * PRESALE_ORDER value: 8 - VVK Bestellung - presale tickets (VVK), maybe personalized 
*  * PRESALE_BILLING value: 9 - VVK Abrechnung 
*  * ORGANIZER_PRESALE_ORDER value: 10 - Veranstalter VVK Bestellung 
*  * SCANNER_ORDER value: 11 - Scannerbestellung 
*  * GUEST_LIST_TICKETS value: 12 - Gästelistenticket - guest list ticket, needed in ticket manager 
*  * EXTERNAL_ORDER value: 13 - externe Bestellung 
*  * COVID_VOUCHER_BILLING value: 14 - Gutschein (Covid) Abrechnung 
*/
@Serializable
enum class OrderTypeId(val value: kotlin.Int) {

    @SerialName(value = "1")
    ORDER(1),

    @SerialName(value = "2")
    SAMPLE_DELIVERY(2),

    @SerialName(value = "3")
    ORGANIZER_TICKETS(3),

    @SerialName(value = "4")
    ORGANIZER_COSTS(4),

    @SerialName(value = "5")
    PRODUCT_COSTS(5),

    @SerialName(value = "6")
    FREE_INVOICE(6),

    @SerialName(value = "7")
    ORDER_IMPORT(7),

    @SerialName(value = "8")
    PRESALE_ORDER(8),

    @SerialName(value = "9")
    PRESALE_BILLING(9),

    @SerialName(value = "10")
    ORGANIZER_PRESALE_ORDER(10),

    @SerialName(value = "11")
    SCANNER_ORDER(11),

    @SerialName(value = "12")
    GUEST_LIST_TICKETS(12),

    @SerialName(value = "13")
    EXTERNAL_ORDER(13),

    @SerialName(value = "14")
    COVID_VOUCHER_BILLING(14);

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value.toString()

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is OrderTypeId) "$data" else null

    /**
    * Returns a valid [OrderTypeId] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): OrderTypeId? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

